import { SxProps } from "@mui/material";

export const fontStyles: SxProps = {
  fontFamily: "Poppins",
  fontWeight: 400,
  fontSize: "12px",
  color: "#7E7E7E",
};

export const activeFontStyles: SxProps = {
  ...fontStyles,
  fontWeight: 600,
  color: "#3D3C42",
};

export const containerStyle: SxProps = {
  display: "flex",
  backgroundColor: "#F9FBFF",
  width: "120px",
  p: "10px 16px",
  borderRadius: "10px",
  justifyContent: "space-between",
  cursor: "pointer",
  boxShadow: "0px 4px 4px 0px #00000040",
};
